import { makeInteger, getHookInfo } from './utils'
import allHooks from './hooks/allHooks'
import { ACTION_TYPE, FIELD_TYPE, BEHAVIOR_TYPE } from './constants'
import moment from 'moment'

async function validationHook(formInputs, fieldInput, objectId) {
  console.log('validate.validationHook', fieldInput, objectId)
  const parts = fieldInput.field.validationHook.split('.')
  const packageName = parts[0]
  const functionName = parts[1]
  return await allHooks[packageName][functionName](fieldInput, objectId, formInputs)
}

async function validateFieldInput(formInputs, fieldInput, validationErrors, object) {
  console.log(`validate.validateFieldInput: ${fieldInput.field.name}`, formInputs, fieldInput)
  const value = fieldInput.currentValue
  fieldInput.validationMessage = ''
  let behaviorType = fieldInput.field.behaviorType
  
  // check for extended ASCII characters
  if (typeof value === 'string' && makeInteger(formInputs.action.type.id) === ACTION_TYPE.submit) {
    for (let i = 0; i < value.length; i++) {
      if (value.charCodeAt(i) > 127) {
        fieldInput.validationMessage = `${fieldInput.field.name} contains extended ASCII character "${value[i]}" at position ${i+1}.  Please use only characters found on the US keyboard as CaseEnsemble does not permit special characters at this time.`
        console.error(fieldInput.validationMessage)
        break
      }
    }
  }

  // if there is a behavior hook, get the behaviorType
  if (makeInteger(fieldInput.field.behaviorType.id) === BEHAVIOR_TYPE.useHook) {
    if (fieldInput.field.behaviorHook) {
      const hookInfo = getHookInfo(fieldInput.field.behaviorHook)
      behaviorType = await allHooks[hookInfo.moduleName][hookInfo.functionName](object, fieldInput.field, formInputs.action)
    }
  }

  // check required fields first
  if (makeInteger(behaviorType.id) === BEHAVIOR_TYPE.required) {
    const isRequiredMessage = `${fieldInput.field.name} is required`
    switch (makeInteger(fieldInput.field.type.id)) {
      case FIELD_TYPE.select:
        if (!value || (value && !value.id)) {
          fieldInput.validationMessage = isRequiredMessage
          console.log(`^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ ${isRequiredMessage}`)
        }
        break
      case FIELD_TYPE.multiSelect:
        if (!value || (value.length === 0)) {
          fieldInput.validationMessage = isRequiredMessage
          console.log(`^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ ${isRequiredMessage}`)
        }
        break
      case FIELD_TYPE.currency:
      case FIELD_TYPE.integer:
      case FIELD_TYPE.number:
        if (value.length === 0) {
          fieldInput.validationMessage = isRequiredMessage
          console.log(`^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ ${isRequiredMessage}`)
        }
        break
      default:
        if (!value) {
          fieldInput.validationMessage = isRequiredMessage
          console.log(`^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ ${isRequiredMessage}`)
        }
    }
  }

  // check all date inputs for valid dates
  if (!fieldInput.validationMessage && makeInteger(fieldInput.field.type.id) === FIELD_TYPE.date) {
    if (value && !moment(value, 'YYYY-MM-DD', true).isValid()) {
      fieldInput.validationMessage = `${fieldInput.field.name} is not a valid date.`
    } else {
      if (moment(value, 'YYYY-MM-DD').year() < 1900) {
        fieldInput.validationMessage = `${fieldInput.field.name} must not specify a year prior to 1900.`
      }
    }
  }

  // check all integer inputs for valid integers
  if (!fieldInput.validationMessage && makeInteger(fieldInput.field.type.id) === FIELD_TYPE.integer) {
    if (!Number.isInteger(Number(value))) {
      fieldInput.validationMessage = `${fieldInput.field.name} is not a valid integer.`
    }
  }

  // validation hook
  if (!fieldInput.validationMessage && fieldInput.field.validationHook) {
    fieldInput.validationMessage = await validationHook(formInputs, fieldInput, object.id)
  }

  if (fieldInput.validationMessage) {
    validationErrors.push(fieldInput.validationMessage)
  }
}

export async function validateInput(formInputs, validationErrors, object) {
  console.log('validate.validateInput', formInputs, object)
  if (makeInteger(formInputs.action.type.id) !== ACTION_TYPE.delete) {
    for (let fieldId in formInputs) {
      // check only formInputs properties that are field id's
      // TODO: put the field id's into a "fields" property
      if (parseInt(fieldId)) {
        const fieldInput = formInputs[fieldId]
        await validateFieldInput(formInputs, fieldInput, validationErrors, object)
      }
    }
  }
}
